<template>
  <div>
    <vxe-grid
      auto-resize
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :height="tableHeight"
      size="small"
      resizable
      border
    >
      <template v-slot:toolbar_form>
        <slot name="header">
          <div class="d-flex">
            <div class="side-frame"></div>
            <div>
              <span style="font-size: 14px; color: #606266">{{
                $l('form_label_data') || '资料'
              }}</span>
              <el-divider v-if="!disabled" direction="vertical"></el-divider>
              <el-button
                v-if="!disabled"
                class="ml-2"
                size="small"
                type="warning"
                plain
                @click="() => $emit('uploadFile')"
                >{{ $l('form_label_upload_data') || '上传资料' }}</el-button
              >
            </div>
          </div>
        </slot>
      </template>
      <template v-slot:opt="{ row }">
        <div>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_downloada') || '下载'"
            placement="top"
          >
            <i class="el-icon-download tool-btn" @click="downloadFile(row)"></i>
          </el-tooltip>
          <el-tooltip
            v-if="!disabled"
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_del') || '删除'"
            placement="top"
          >
            <i
              class="el-icon-delete tool-btn"
              @click="del(row.materialDocCode)"
            ></i>
          </el-tooltip>
        </div>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l('INDEX.table_label_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import tableColumns from './table-columns'
export default {
  props: {
    tableData: {
      type: Array,
      default: () => []
    },
    disabled: {
      type: Boolean,
      default: false
    },
    tableHeight: {
      type: Number,
      default: 300
    }
  },
  data() {
    return {
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form'
        },
        refresh: {
          query: () => this.$emit('reload')
        },
        zoom: true,
        custom: true
      },
      tableColumns: tableColumns(this)
    }
  },
  methods: {
    downloadFile(row) {
      const link = document.createElement('a')
      // download属性
      link.setAttribute('download', row.originalFileName)
      // href链接
      link.setAttribute('href', row.originalFileUrl)
      // 自执行点击事件
      link.click()
      document.body.removeChild(link)
    },
    del(materialDocCode) {
      this.$confirm(
        this.$l('INDEX.tips_delete') || '是否要删除该记录？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning'
        }
      ).then(() => {
        this.$api.materialInfoDocDelApi({ materialDocCode }).then(() => {
          this.$message({
            showClose: true,
            message: this.$l('INDEX.tips_delete_ok') || '删除成功！',
            type: 'success'
          })
          this.$emit('reload')
        })
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.side-frame {
  padding: 1px 5px;
  border-left: 3px solid $color-warning;
  height: 20px;
  margin-top: 5px;
}
</style>
